import { handleRequest } from "../utilities/requestHandler";

export const getCustomerByIdForCusSites = (customerId) => 
    handleRequest("get", `/cus_sites/getcustomer/${customerId}`);

export const getProdutsUniqueBySiteNumber = (selectedSite) =>
    handleRequest("post", "/products/uniquebysitenumber", { site_number: selectedSite });

export const resolveUploadProducts = (selectedSite, partNumbers = []) =>
    handleRequest("post", "/products/resolve-upload", { site_number: selectedSite, part_numbers: partNumbers });

export const scheduleUpdate = (req_body) =>
    handleRequest("post", "/orders/scheduleUpdate", req_body);

export const schedule = (req_body) =>
    handleRequest("post", "/orders/schedule", req_body);
